// 학생이 지금 플랫폼의 "어디"에 있는지 추적하는 초경량 스토어.
// useEngagement 훅이 이 값을 구독해 좌석 문서에 현재 위치 + 위치별 체류시간을 기록한다.
//
// location id 규칙(맵 키로 쓰이므로 '.', '/', '[', ']', '~', '*' 금지):
//   'home'                              — 코스 선택 화면
//   'sim:<simulatorId>'                 — 자유 시뮬레이터
//   'guided:<courseType>:day<N>[:<sim>]' — 가이드 코스 내 위치

let current = { id: 'home', label: '코스 선택' };
const listeners = new Set();

export function setLocation(id, label) {
  const nextId = id || 'home';
  if (current.id === nextId && current.label === (label || nextId)) return;
  current = { id: nextId, label: label || nextId };
  listeners.forEach((fn) => { try { fn(current); } catch { /* noop */ } });
}

export function getLocation() {
  return current;
}

export function subscribeLocation(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
